export var dsm5 = {
    name: 'DSM-5',
    id: 'dsm5',
    depth: 2,
    enableToInclueOtherTagToTopLevel: true,
    tags: [
        {
            name: 'Neurodevelopmental disorders',
            id: 'jZ3Xv9'
        },
        {
            name: 'Schizophrenia spectrum and other psychotic disorders',
            id: 'kW2buP'
        },
        {
            name: 'Bipolar and related disorders',
            id: 'Wf4VMg'
        },
        {
            name: 'Depressive disorders',
            id: 'Kj6TFA'
        },
        {
            name: 'Anxiety disorders',
            id: 'A2nr4M'
        },
        {
            name: 'Obsessive-compulsive and related disorders',
            id: 'E8mPL4'
        },
        {
            name: 'Substance-related and addictive disorders',
            id: 'Lj8ZsH'
        },
        {
            name: 'Others',
            id: 'e5QFSH',
            children: [
                {
                    name: 'Trauma- and stressor-related disorders',
                    id: 'j8YneP'
                },
                {
                    name: 'Dissociative disorders',
                    id: 'Z4dM5a'
                },
                {
                    name: 'Somatic symptom and related disorders',
                    id: 'S5rxsw'
                },
                {
                    name: 'Feeding and eating disorders',
                    id: 'U9gPi5'
                },
                {
                    name: 'Elimination disorders',
                    id: 'jZ6vxq'
                },
                {
                    name: 'Sleep–wake disorders',
                    id: 'R8kUvM'
                },
                {
                    name: 'Sexual dysfunctions',
                    id: 'Fj84Kp'
                },
                {
                    name: 'Gender dysphoria',
                    id: 'D5hAiJ'
                },
                {
                    name: 'Disruptive, impulse-control, and conduct disorders',
                    id: 'E8uYBV'
                },
                {
                    name: 'Neurocognitive disorders',
                    id: 'Nc4zSb'
                },
                {
                    name: 'Personality disorders',
                    id: 'Kz47CX'
                },
                {
                    name: 'Paraphilic disorders',
                    id: 'q5BFPL'
                },
                {
                    name: 'Cognitive process',
                    id: 'k3YEz4'
                },
                {
                    name: 'Unspecified',
                    id: 'q2QnHD'
                }
            ]
        }
    ]
};
